import { Button, Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { filter } from "lodash";
import React, { useEffect } from "react";
import { toggleBodyScroll } from "../../util/common";

const useStyle = makeStyles((theme) => ({
  popupOverlay: {
    position: "fixed",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    height: "100vh",
    width: "100vw",
    overflowY: "scroll",
    // background: "rgba(0, 0, 0, .9)",
    zIndex: 1200,
  },
  popupContainer: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    height: "auto",
    overflowY: "scroll",
    width: "auto",
    background: "#0d091b",
    zIndex: 1201,
  },
  closeBtn: {
    textTransform: "capitalize",
    padding: "12px 15px",
    background: "linear-gradient(117deg, #5d6063 3%, #505050 96%)",
    boxShadow: "4px -4px 60px 0 rgba(255, 255, 255, 0.05)",
    borderRadius: "99px",
    position: "fixed",
    left: "50%",
    bottom: theme.spacing(2.25),
    transform: "translateX(-50%)",
    zIndex: 1201,
    color: "#FFF",
    fontSize: 14,
    fontFamily: "Ubuntu",
    "& img": {
      marginLeft: 6,
      height: 12,
      width: 12,
    },
  },
  noFullScreen: {
    maxHeight: "85vh !important",
    width: "70vw !important",
    top: "6.25vh",
    left: "15vw",
    borderRadius: 15,
    background: "#19132A",
    // overflow: "hidden",
  },
  bottomScreenPopup: {
    maxHeight: "280px",
    width: "-webkit-fill-available",
    top: "auto",
    bottom: 0,
    borderRadius: 15,
    // overflow: "hidden",
  },
}));

const Popup = ({
  handlePopupClose,
  children,
  noCloseButton = false,
  styleObj = {},
  noFullScreen = false,
  bottomScreenPopup = false,
}) => {
  const classes = useStyle();

  //   useEffect(() => {
  //     toggleBodyScroll();
  //     return () => toggleBodyScroll(true);
  //   }, []);

  return (
    <>
      {noFullScreen && (
        <div className={classes.popupOverlay} onClick={handlePopupClose} />
      )}
      <Grid
        container
        direction="row"
        className={`${classes.popupContainer} ${
          noFullScreen ? classes.noFullScreen : ""
        }`}
        style={styleObj}
      >
        <Grid item xs={12}>
          {children}
        </Grid>
      </Grid>
    </>
  );
};

export default Popup;
